// Thank you Joseph Chamochumbi for these nice hooks
import { useCallback, useEffect, useReducer, useRef } from "react";
type Callback<Args extends unknown[], Ret = unknown> = (...args: Args) => Ret;

export const useDebounceCallback = <Args extends unknown[], Ret = unknown>(
  callback: Callback<Args, Ret>,
  delay = 500
) => {
  const timer = useRef<number>();
  const callbackRef = useRef(callback);

  useEffect(() => {
    return () => window.clearTimeout(timer.current);
  }, []);
  return useCallback<(...args: Args) => void>(
    (...args: Args) => {
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(callbackRef.current, delay, ...args);
    },
    [delay]
  );
};

export const useDebounceValue = <Value>(value: Value, delay = 500): Value => {
  const [debounced, setDebounced] = useReducer(
    (_prev: Value, next: Value) => next,
    value
  );
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
};
